export const getFlagList = () => {
  return {
    algeria: "Algeria-DZ",
    angola: "Angola-AO",
    argentina: "Argentina-AR",
    australia: "Australia-AU",
    austria: "Austria-AT",
    azerbaijan: "Azerbaijan-AZ",
    bahrain: "Bahrain-BH",
    bangladesh: "Bangladesh-BD",
    belarus: "Belarus-BY",
    belgium: "Belgium-BE",
    bolivia: "Bolivia-BO",
    brazil: "Brazil-BR",
    bulgaria: "Bulgaria-BG",
    cambodia: "Cambodia-KH",
    cameroon: "Cameroon-CM",
    canada: "Canada-CA",
    chile: "Chile-CL",
    china: "China-CN",
    colombia: "Colombia-CO",
    "costa-rica": "Costa-Rica-CR",
    "cote-d'ivori": "Cote-d'Ivori-CI",
    croatia: "Croatia-HR",
    "czech-republic": "Czech-Republic-CZ",
    denmark: "Denmark-DK",
    "dominican-republic": "Dominican-Republic-DO",
    ecuador: "Ecuador-EC",
    egypt: "Egypt-EG",
    "el-salvador": "El-Salvador-SV",
    eritrea: "Eritrea-ER",
    estonia: "Estonia-EE",
    "european-union": "European-Union-EU",
    finland: "Finland-FI",
    france: "France-FR",
    "france-britain-split": "France-britain-split",
    gabon: "Gabon-GA",
    georgia: "Georgia-GE",
    germany: "Germany-DE",
    greece: "Greece-GR",
    greenland: "Greenland-GL",
    guadeolupe: "Guadeolupe-GP",
    guatemala: "Guatemala-GT",
    honduras: "Honduras-HN",
    "hong-kong": "Hong-Kong-HK",
    hungary: "Hungary-HU",
    india: "India-IN",
    indonesia: "Indonesia-ID",
    iran: "Iran-IR",
    iraq: "Iraq-IQ",
    ireland: "Ireland-IE",
    israel: "Israel-IL",
    italy: "Italy-IT",
    japan: "Japan-JP",
    jordan: "Jordan-JO",
    kazakhstan: "Kazakhstan-KZ",
    kenya: "Kenya-KE",
    kuwait: "Kuwait-KW",
    kyrgystan: "Kyrgystan-KG",
    libya: "Libya-LY",
    luxembourg: "Luxembourg-LU",
    malaysia: "Malaysia-MY",
    malta: "Malta-MT",
    martinique: "Martinique-MQ",
    mexico: "Mexico-MX",
    morroco: "Morroco-MA",
    mozambique: "Mozambique-MZ",
    netherlands: "Netherlands-NL",
    "new-zealand": "New-Zealand-NZ",
    nigeria: "Nigeria-NG",
    norway: "Norway-NO",
    oman: "Oman-OM",
    pakistan: "Pakistan-PK",
    palestine: "Palestine-PS",
    panama: "Panama-PA",
    peru: "Peru-PE",
    philippines: "Philippines-PH",
    poland: "Poland-PL",
    portugal: "Portugal-PT",
    "puerto-rico": "Puerto-Rico-PR",
    qatar: "Qatar-QA",
    rainbow: "Rainbow",
    reunion: "Reunion-RE",
    romania: "Romania-RO",
    russia: "Russia-RU",
    "saudi-arabia": "Saudi-Arabia-SA",
    senegal: "Senegal-SN",
    serbia: "Serbia-RS",
    singapore: "Singapore-SG",
    slovakia: "Slovakia-SK",
    slovenia: "Slovenia-SI",
    "south-africa": "South-Africa-ZA",
    "south-korea": "South-Korea-KR",
    spain: "Spain-ES",
    split: "France-britain-split",
    sudan: "Sudan-SD",
    sweden: "Sweden-SE",
    switzerland: "Switzerland-CH",
    syria: "Syria-SY",
    taiwan: "Taiwan-TW",
    thailand: "Thailand-TH",
    tunisia: "Tunisia-TN",
    turkey: "Turkey-TR",
    ukraine: "Ukraine-UA",
    "united-arab-emirates": "United-Arab-Emirates-AE",
    "united-kingdom": "United-Kingdom-GB",
    "united-states": "United-States-US",
    uruguay: "Uruguay-UY",
    uzbekistan: "Uzbekistan-UZ",
    venezuela: "Venezuela-VE",
    vietnam: "Vietnam-VN",
  };
};
